<template>
    <div  class="swipper">
        <div  id="jssor_1" style="position:relative;margin:0 auto;top:0px;left:0px;width:400px;height:60px;overflow:hidden;visibility:;">  
            <div data-u="slides" style="cursor:default;position:relative;top:0px;left:0px;width:400px;height:60px;overflow:hidden;">
                <!-- <gameBanner :position="'t'"></gameBanner> -->
                <div><img src="assets/images/topbanner1S.jpg" style="width:400px"></div>
                <div><img src="assets/images/topbanner2.jpg" style="width:400px"></div>
                <div><img src="assets/images/topbanner3S.jpg" style="width:400px"></div>
            </div>
        </div>
    </div>
</template>

<script>
import gameBanner from '../contentsLeft/gameBanner'

import {
mapGetters
} from 'vuex'
export default {
    computed: {
        ...mapGetters([
        ]),
    },
    components: {
        gameBanner
    },
    data() {
    return {
        lang: window.lang,
    }
    },
    methods: {
    
    },
    beforeMount() {
    
    },
    mounted() {
        var options = { $AutoPlay: 1, $SlideDuration: 1800, }
        var jssor_1_slider = new $JssorSlider$("jssor_1", options)

        var MAX_WIDTH = 400;
        function ScaleSlider() {
            var containerElement = jssor_1_slider.$Elmt.parentNode;
            // var containerWidth = containerElement.clientWidth;
            var containerWidth = 400;
            if (containerWidth) {
                var expectedWidth = Math.min(MAX_WIDTH || containerWidth, containerWidth);
                $('#jssor_1').height(50)
                jssor_1_slider.$ScaleWidth(containerWidth);
            }
            else {
                window.setTimeout(ScaleSlider, 30);
            }
        }

        ScaleSlider();

        $Jssor$.$AddEvent(window, "load", ScaleSlider);
        $Jssor$.$AddEvent(window, "resize", ScaleSlider);
    }
}
</script>
<style lang="scss">
    @import "~@/styles/components/sliderImage";
    /*jssor slider loading skin spin css*/
    .jssorl-009-spin img {
        animation-name: jssorl-009-spin;
        animation-duration: 1.6s;
        animation-iteration-count: infinite;
        animation-timing-function: linear;
    }

    @keyframes jssorl-009-spin {
        from { transform: rotate(0deg); }
        to { transform: rotate(360deg); }
    }

    /*jssor slider bullet skin 032 css*/
    .jssorb032 {position:absolute;}
    .jssorb032 .i {position:absolute;cursor:pointer;}
    .jssorb032 .i .b {fill:#fff;fill-opacity:0.7;stroke:#000;stroke-width:1200;stroke-miterlimit:10;stroke-opacity:0.25;}
    .jssorb032 .i:hover .b {fill:#000;fill-opacity:.6;stroke:#fff;stroke-opacity:.35;}
    .jssorb032 .iav .b {fill:#000;fill-opacity:1;stroke:#fff;stroke-opacity:.35;}
    .jssorb032 .i.idn {opacity:.3;}

    /*jssor slider arrow skin 051 css*/
    .jssora051 {display:block;position:absolute;cursor:pointer;}
    .jssora051 .a {fill:none;stroke:#fff;stroke-width:360;stroke-miterlimit:10;}
    .jssora051:hover {opacity:.8;}
    .jssora051.jssora051dn {opacity:.5;}
    .jssora051.jssora051ds {opacity:.3;pointer-events:none;}
</style>


// WEBPACK FOOTER //
// resources/wob/vue/apps/home/myheader/sliderImage.vue